import { REPORTS_HISTORY_REMOVE, REPORTS_HISTORY_SET, REPORTS_HISTORY_UPDATE } from './report-history-actions.js';

const initialState = {
  files: [],
}

export default function(state = initialState, action) {
  switch (action.type) {
    case REPORTS_HISTORY_SET: {
      return {
        ...state,
        files: action.data,
      }
    }
    case REPORTS_HISTORY_REMOVE: {
      return {
        ...state,
        files: state.files.filter(file => file.reportId !== action.data),
      }
    }
    case REPORTS_HISTORY_UPDATE: {
      return {
        ...state,
        files: state.files.map(file => file.reportId === action.data.reportId ? {...file, ...action.data} : file),
      }
    }
    default: {
      return state;
    }
  }
}